const TextArea = ({entity, name, cols="40", rows="1", changeHandler, valueGetter=null}) => {
    const changeHandlerWrapper = (event) => {
        const {value} = event.target
        changeHandler(entity.id, name, value)
    }
    return (
        <textarea
            cols={cols}
            rows={rows}
            value={!!valueGetter ? valueGetter(entity, name) : entity[name]}
            onChange={changeHandlerWrapper}
        />
    )
}

export default TextArea